import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Link from 'flarum/common/components/Link';
export default function addBadgesToPostFooter() {
  // Helper to get visible badges array from user attributes
  const getVisibleBadges = user => {
    return user.attribute('visibleBadges') || [];
  };
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    const user = post.user();
    if (!user) return;
    if (post.isHidden()) return;
    const badgeCount = user.attribute('badgeCount') || 0;
    if (badgeCount === 0) return;
    const visibleBadges = getVisibleBadges(user);
    if (visibleBadges.length === 0) return;
    const remainingCount = badgeCount - visibleBadges.length;
    items.add('badges', m(Link, {
      href: app.route('user.badges', {
        username: user.slug()
      }),
      className: "PostBadges"
    }, visibleBadges.map((badge, index) => m("span", {
      className: "PostBadges-item",
      title: badge.name,
      key: index
    }, m("i", {
      className: badge.icon
    }))), remainingCount > 0 && m("span", {
      className: "PostBadges-more"
    }, "+", remainingCount)), -10);
  });
}